import { render, staticRenderFns } from "./AddRevenueManagementDialog.vue?vue&type=template&id=dc50a292&scoped=true"
import script from "./AddRevenueManagementDialog.vue?vue&type=script&lang=js"
export * from "./AddRevenueManagementDialog.vue?vue&type=script&lang=js"
import style0 from "./AddRevenueManagementDialog.vue?vue&type=style&index=0&id=dc50a292&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc50a292",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc50a292')) {
      api.createRecord('dc50a292', component.options)
    } else {
      api.reload('dc50a292', component.options)
    }
    module.hot.accept("./AddRevenueManagementDialog.vue?vue&type=template&id=dc50a292&scoped=true", function () {
      api.rerender('dc50a292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/TuitionManagement/dialog/AddRevenueManagementDialog.vue"
export default component.exports